import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.common.white,
    zIndex: theme.zIndex.drawer + 1,
    boxShadow: 'none',
    maxHeight: theme.spacing(8.875),
  },
  logoImg: {
    maxWidth: theme.spacing(12),
    maxHeight: theme.spacing(6.5),
    margin: theme.spacing(1, 2),
    fill: theme.palette.primary.dark,
  },
}))
